<template>
    <Sheet v-loading="loading.actions['systemNews']">
        <h2>{{routeTitle}}</h2>
        <el-row :gutter="24">
          <el-col :span="6">
            <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF" style="width:100%">
              <thead class="ncut-thead-menu">
                <tr>
                  <th style="width: 1em;"></th>
                  <th>
                    公告標題
                  </th>
                  <th style="width: 7em;">
                    公告時間
                  </th>
                </tr>
              </thead>
                <tbody class="ncut-tbody-menu">
                  <tr>
                    <td colspan="3" style="padding:0.3125em; text-align: left;">
                    <span class="glyphicon glyphicon-pencil" style="margin-right: 4px;"
                      @click="newDoc()"><a href="#"><i class="el-icon-plus"/>新增公告項目</a></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <el-radio-group v-model="mode" size="small">
                        <el-radio-button key="O1" :label="1" >全部</el-radio-button>
                        <el-radio-button key="O2" :label="2" >要顯示</el-radio-button>
                        <el-radio-button key="O3" :label="3" >不顯示</el-radio-button>
                      </el-radio-group>
                    </td>
                  </tr>
                    <tr v-for="(item, index) in filteredCars" :key="item.id" :index="item.id" :name="item.id"
                        @click="rowClick(index, item)"
                        v-bind:class="{ selected: index == selectedRowIndex }">
                      <td><i class="el-icon-search"></i></td>
                      <td style="text-align: left;">{{item.text2}}</td>
                      <td style="text-align:left;">起:{{item.startDate | dateFormat}} - 迄:{{item.endDate | dateFormat}}</td>
                    </tr>
                    <tr v-if="0 == newsList.length">
                      <td>無</td>
                    </tr>
                </tbody>
            </table>
            <el-pagination
              background
              layout="prev, pager, next"
              :pager-count="11"
              :page-size="pageSize"
              :total="total"
              v-if="total>pageSize">
            </el-pagination>
          </el-col>
          <el-col :xl="18" :lg="18" :md="18" :sm="24" :xs="24">
            <template 
              v-if="(null != newsData) && (-1 < selectedRowIndex)">
              <table cellpadding="0" cellspacing="0" style="width:100%">
                <tbody>
                  <tr>
                    <td class="ncut-edit-form-text ncut-require-title" style="width:8em;">角色：</td>
                    <td class="ncut-base-form-ipt" style="padding-top: 15px;" colspan="3">
                      <el-select v-model="roleItem" multiple placeholder="請選擇" style="width: 30em;" tabindex="1">
                        <el-option
                          v-for="item in roles"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </td>
                  </tr>
                  <tr>
                    <td class="ncut-edit-form-text">公告類型：</td>
                    <td class="ncut-base-form-ipt" colspan="3">
                      <el-select v-model="newsData.newsType" placeholder="請選擇" tabindex="2">
                        <el-option
                          v-for="item in codeList"
                          :key="'n'.concat(item.no)"
                          :label="item.codeName"
                          :value="item.no">
                        </el-option>
                        <el-option key="n00" label="無" :value="0" :disabled="true"/>
                      </el-select>
                    </td>
                  </tr>
                  <tr>
                    <td class="ncut-edit-form-text">公告時間：</td>
                    <td class="ncut-base-form-ipt" colspan="3">
                      <el-date-picker
                        v-model="tmpDate"
                        :unlink-panels=true
                        type="daterange"
                        range-separator="至"
                        start-placeholder="開始日期"
                        end-placeholder="结束日期"
                        tabindex="3"
                        :picker-options="pickerOptions1">
                      </el-date-picker> 
                    </td>
                  </tr>
                  <tr>
                    <td class="ncut-edit-form-text ncut-require-title">公告標題：</td>
                    <td class="ncut-base-form-ipt" colspan="3">
                      <el-input v-model="newsData.title" placeholder="請輸入標題"  tabindex="4"
                        maxlength="30"
                        show-word-limit></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td class="ncut-edit-form-text ncut-require-title">公告主題：</td>
                    <td class="ncut-base-form-ipt" colspan="3">
                      <ckeditor :height="'300px'" :config="config"
                        v-model="newsData.content"
                        v-if="newsData.newsType==2" tabindex="5"/>
                      <el-input type="textarea" :rows=3 placeholder="請輸入公告主題" tabindex="6"
                        v-model="newsData.content"
                        v-else/>
                    </td>
                  </tr>
                  <tr>
                    <td class="ncut-edit-form-text">是否顯示：</td>
                    <td class="ncut-base-form-ipt" style="width: 15em;">
                      <el-radio-group v-model="newsData.isDelete" size="small" tabindex="7">
                        <el-radio-button key="D1" :label="false" >是</el-radio-button>
                        <el-radio-button key="D2" :label="true" >否</el-radio-button>
                      </el-radio-group>
                    </td>
                    <td class="ncut-edit-form-text" style="width:8em;">是否顯示附件：</td>
                    <td class="ncut-base-form-ipt">
                      <el-radio-group v-model="newsData.isShow" size="small" tabindex="8">
                        <el-radio-button key="D1" :label="false" >是</el-radio-button>
                        <el-radio-button key="D2" :label="true" >否</el-radio-button>
                      </el-radio-group>
                    </td>
                  </tr>
                  <tr>
                    <td class="ncut-edit-form-text ncut-require-title">置頂排序：</td>
                    <td class="ncut-base-form-ipt" colspan="3">
                      <el-input-number v-model="newsData.sort" :min="0" :max="1000" label="置頂排序" style="width:6em;" tabindex="9" size="small" controls-position="right"/>（預設為 0，如輸入數字，可決定公告置頂，數字越大順位越高。）
                    </td>
                  </tr>
                  <tr>
                    <td class="ncut-edit-form-text">
                      <i class="el-icon-upload"></i>附件上傳：
                    </td>
                    <td class="ncut-base-form-ipt" colspan="3"> 
                      <ul style="clear:both"  class="response"
                        v-show="newsData.info!=null && newsData.info.length > 0">
                        <li class="sel-file" :key="f.menuID" :index="f.menuID" :name="f.menuID"
                          v-for="f in newsData.info"
                          v-show="f.status!='D'">
                          <span v-if="f.img != null">
                            <el-image 
                              style="width:1.38em; height:1.38em;"
                              :src="base.concat('api/News/getAttach/').concat(f.rowId)" 
                              :preview-src-list="getSrcList(f)"
                              ref="attachImg"
                              @mouseover="clickImage()" >
                            </el-image>{{f.name}}{{f.ext}}
                          </span>
                          <span v-else>
                            <a href="#"  @click="setUrl(f)" :title="f.name"
                              v-if="f.type === 'application/pdf'">
                              <span>
                                <img src="@/assets/images/pdf.gif" style="width:1.5em; height:1.5em;">
                              </span>{{f.name}}{{f.ext}}
                            </a>
                            <a :href="base.concat('api/News/getAttach/').concat(f.rowId)" target="_blank" :title="f.name"
                              v-else>
                              <span>
                                <img v-if="f.type === 'application/msword'" src="@/assets/images/word.gif" style="width:1.5em; height:1.5em;">
                                <img v-else-if="f.type === 'image/jpeg'" src="@/assets/images/image.gif" style="width:1.5em; height:1.5em;">
                                <img v-else src="@/assets/images/attachment.png" style="width:1.5em; height:1.5em;">
                              </span>{{f.name}}{{f.ext}}
                            </a>
                          </span>
                          &nbsp;&nbsp;
                          <i class="el-icon-delete" title="移除附件"
                                @click="f.status='D'"></i>
                        </li>
                      </ul>
                      <el-upload
                        class="upload-demo"
                        accept="image/jpeg,image/gif,image/png,application/pdf,application/msword,application/vnd.oasis.opendocument.text"
                        drag
                        :action="action"
                        :file-list="fileList"
                        :on-success="handleAvatarSuccess"
                        :on-remove="handleChange"
                        :limit="3"
                        :before-upload="onBeforeUpload"
                        tabindex="10">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">將文件拖到此處，或<em>點擊上傳</em></div>
                      </el-upload>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div style='text-align: left;'>
                <font style="color:red;">* 紅色為必填欄位</font>
              </div>
              <el-row style="padding: 0.25em 2em; display: inline-block;" tabindex="11">
                <el-button type="success" @click="save()"><i class="el-icon-check"></i>&nbsp;{{$t('Save_cmd')}}</el-button>
                <el-button type="warning" @click="removeNew()"><i class="el-icon-delete"></i>&nbsp;{{$t('Del_cmd')}}</el-button>
              </el-row>
              <el-dialog
                :visible.sync="showDialog"
                @closed="onDialogClosed">
                <el-row>
                  <el-col :span="20" style="padding: 0.5rem 0.5rem 0 0.5rem;">
                    <p class="arrow"
                      v-if="pdfDoc!=''">
                      頁數：<span class="turn" style="font-weight: bold;"
                      :style="{'color': pBtnColor}" 
                      @click="changePdfPage(0)"><i class="el-icon-arrow-left"></i>{{$t('Preview_txt')}}</span>
                      {{currPdfPage}} / {{pageCount}}
                      <span class="turn" style="font-weight: bold;"
                        :style="{'color': nBtnColor}"
                        @click="changePdfPage(1)">{{$t('NextPage_txt')}}<i class="el-icon-arrow-right"></i></span>
                    </p>
                  </el-col>
                  <el-col :span="4" style="text-align: end; padding: 0.5rem 0.5rem 0 0.5rem;">
                    <el-button round icon="el-icon-close" size="mini"
                      @click="clearFile()">關閉附件</el-button>
                  </el-col>
                </el-row>                         
                <pdf scale="page-width" style="width:100%;margin:0.25em auto;border: 1px solid #BBCDC5 !important;"
                  :src="pdfDoc" 
                  :page="currPdfPage"
                  @num-pages="pageCount=$event"
                  @page-loaded="currPdfPage=$event"
                  @loaded="loadPdfHandler"></pdf>
              </el-dialog>
            </template>
          </el-col>
        </el-row>
  </Sheet>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import routeTitleMixin from './routeTitleMixin';
import Ckeditor from 'vue-ckeditor2';
import {base} from '../constants';
import UploadMixin from '../uploadMixin';
import pdf from 'vue-pdf';

export default {
  name: 'news',
  mixins: [routeTitleMixin, UploadMixin],
  components: { 
    Ckeditor, pdf
  },
  data () {
    return {
      showDialog: false,  
      pdfDoc: '',
      numPages: 0,
      currPdfPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      base: base,
      fileList: [],
      tmpDate: [new Date(), new Date()],
      roleItem: [],
      mode: 1,
      currentPage: 1,
      selectedRowIndex: -1,
      pageSize: 20,
      total: 0,
      url: 'upload/uploadV2',
      pickerOptions1: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      config: {
        toolbar: [
          [ 'Source', '-','Preview', '-', 'Templates' ],
          [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ],
          [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ],
          [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat' ],
          [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl', 'Language' ],
          [ 'Link', 'Unlink', 'Anchor' ],
          [ 'Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe' ] ,
          [ 'Styles', 'Format', 'Font', 'FontSize' ],
          [ 'TextColor', 'BGColor' ] ,
          [ 'Maximize', 'ShowBlocks' ] ,
          [ 'About' ]
        ]
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('auth', ['name', 'userId', 'roleId']),
    ...mapState('role', ['roles']),
    ...mapState('codeDt', ['codeList']),
    ...mapState('systemNews',['newsData', 'newsList']),
    
  	filteredCars: function(){
      var cars = []
      if (!this.isNull(this.newsList)) {
        if(this.mode == 0){
          cars = this.newsList
        }
        else
        {
          cars = this.newsList.filter(car => {
            switch(this.mode) {
              case 1:
                return true
                break;
              case 2:
                if (!car.isDelete) {                
                  return true
                }
                break;
              case 3:
                if (car.isDelete) {                
                  return true
                }
                break;
            }
            return false
          })
        }
      }
      this.total = cars.length;
      return cars.slice((this.currentPage-1)*this.pageSize, this.currentPage*this.pageSize)
    },
    pBtnColor () {
      return (this.currPdfPage==1?'#b2bbbe': '#207f4c');
    },
    nBtnColor () {
      return (this.currPdfPage==this.pageCount?'#b2bbbe': '#c1651a');
    }
  },
  filters: {  
    dateFormat:function(input) {   
       var d = new Date(input);
       var year = d.getFullYear();
       var month = d.getMonth() + 1;
       var day = d.getDate() <10 ? '0' + d.getDate() : '' + d.getDate(); 
       return  year+ '/' + month + '/' + day ; 
    }  
  },
  methods: {
    ...mapActions('role', {
      getRoleAll: 'getRolesAction',
    }),
    ...mapActions('codeDt', {
      getCode: 'getCodeNo',
    }),
    ...mapActions('systemNews', {
      getNewsAll: 'getNewsList',
      getNewsData: 'getNewsData',
      remove: 'removeNewsData',
      update: 'updateNewsData',
    }),
    isNull(data) {
      var ret = ((data != null) && (data != undefined) && (data != "null") ? false : true);
      return ret;
    },
    isShow (item) {
      return (item.status==null || item.status!='D')
    },
    onDialogClosed(){
      this.showDialog = false;
      this.pdfDoc = '';
    },
    clearFile(){
      this.onDialogClosed();
    },
    changePdfPage (val) {
      if (val === 0 && this.currPdfPage > 1) {
        this.currPdfPage--;
      }
      if (val === 1 && this.currPdfPage < this.pageCount) {
        this.currPdfPage++
      }
    }, 
    loadPdfHandler (e) {
      this.currPdfPage = 1;
    },
    setUrl(data) {
      this.pdfDoc = pdf.createLoadingTask(this.base.concat('api/News/getAttach/').concat(data.rowId));
      this.pdfDoc.then(pdf => {
                                this.numPages = pdf.numPages;
                              }); 
      this.showDialog = true;
    },
    getSrcList(f) {
      return [this.base.concat('api/News/getAttach/').concat(f.rowId)]
    },
    async rowClick(index, item) {
      this.selectedRowIndex = index;
      
      const {success} = await this.getNewsData(item.id);

      if (success) {
        //this.roleItem = this.newsData.roleId.split(",")
        this.roleItem = this.newsData.roleId.split`,`.map(x=>+x);
        this.tmpDate = [ this.newsData.startDate, this.newsData.endDate];
      }
    },
    async newDoc() {
      const {success} = await this.getNewsData(0);
      if (success) {
        this.selectedRowIndex = 0;
        this.fileList = [];
        this.roleItem = [];
      }
    },
    checkSaveData () {
      let msg = ''

      if ((this.roleItem === null) || (this.roleItem.length === 0)) {
        msg = '請選擇角色';
      } else if (this.newsData.content === '') {
        msg = '請輸入公告主題';
      } else if ((this.newsData.content === null) || (500 < this.newsData.content.length)) {
        msg = '公告內容最多 500 個字';
      } else {
        if ((this.fileList != null) && (this.fileList.length>0)) {
          if (this.newsData.info === null) {
            this.newsData.info = this.fileList;
          } else {
            var len = this.fileList.length;
            for (var it = 0; it < len; it++) {
              this.newsData.info.push(this.fileList[it]);
            }
          }
        }
        if ((3 == this.newsData.newsType) && 
            ((this.newsData.info === null) || (this.newsData.info.length == 0))) {
          msg = '請選擇附件';
        } else {
          this.newsData.roleId = (this.roleItem.length>1?this.roleItem.join():this.roleItem[0])
          //this.roleItem = [];
        }
      }

      return msg
    },
    async removeNew () {
      try {
        await this.$confirm('確定要刪除嗎?', {
                        type: 'danger',
                    });
        const {success} = await this.remove(this.newsData.newsId);
        if (success) {
          this.$message.success('刪除成功');
          await this.getNewsAll();
        } else {
          this.$message.warning('刪除失敗，請重試一次');
        }
      } catch (e) {
        if (e !== 'cancel') {
          this.$message({
                          type: 'error',
                          message: '發生錯誤，請重試一次!'
                        });
        }
      }
    },
    async save () {
      var vm = this
      let msg = this.checkSaveData()
      if (msg.length === 0) {        
        this.newsData.startDate = this.tmpDate[0];
        this.newsData.endDate = this.tmpDate[1];
        this.newsData.createUser = this.userId;
        const {success} = await this.update({
                            ...this.newsData,
                        });

        if (success) {
          this.$message({
                          type: 'success',
                          message: '異動成功'
                        });
          await this.getNewsAll();
          this.selectedRowIndex = -1;
          this.fileList = [];
          this.roleItem = [];
          // this.roleItem = this.newsData.roleId.split`,`.map(x=>+x);
          // this.tmpDate = [ this.newsData.startDate, this.newsData.endDate]  
        } else {
          this.$message({
                          type: 'danger',
                          message: '異動失敗，請重試一次'
                        });
        }
      } else {
        this.$message.error('對不起,' + msg)
        return false
      } 
    },
    onBeforeUpload(file)
    {
      const isIMAGE = file.type === 'image/jpeg'||'image/gif'||'image/png'||'application/pdf'||'application/msword'||'application/vnd.oasis.opendocument.text';
      const isLt1M = file.size > 10485760;
      
      if (!isIMAGE) {
        this.$message.error('文件格式不支援!');
      }
      if (isLt1M) {
        this.$message.error('檔案大小請勿超過 10MB!');
      }
      
      return (!isIMAGE && isLt1M? false:true);
    },
    handleAvatarSuccess(res, file) {
      if (this.fileList != null) {
        this.fileList.push(file.response);
      } else {
        this.fileList = file.response;
      }
    },
    handleChange(file, fileList) {
    //this.fileList = fileList.slice(-3);
      if (null != this.fileList) {          
        var len = this.fileList.length;
        var idx = -1;
        for (var i = 0; i < len; i++) {
          if (this.fileList[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.fileList.splice(idx,1);
        }
      }
    },
    clickImage($event) {
      // const elem = this.$refs.attachImg;
      // elem[0].click()
      this.$refs['attachImg'][0].showViewer = true;
    }
  },

  async created() {
    await this.getRoleAll();
    await this.getCode(1);
    await this.getNewsAll();
    this.selectedRowIndex = -1;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
